import { Injectable, InjectionToken } from '@angular/core';
import { LookupDataServiceBase } from 'src/app/core/lookup-data-service-base.class';
import { IColumnDef } from 'src/app/core/models/ui/column-defs/column-def.interface';
import { UserAccount } from 'src/app/core/models/table-entities/user-account.interface';
import { ConfigService } from '../config.service';
import { HttpClient } from '@angular/common/http';
import { PermissionType } from 'src/app/core/constants/permissions.enum';
import { DataServiceBase } from 'src/app/core/data-service-base.class';
import { Observable, map, of } from 'rxjs';
import { GenderLookupService } from '../lookup-services/gender-lookup.service';

export const USER_ACCOUNT_SERVICE_TOKEN = new InjectionToken<
  DataServiceBase<UserAccount>
>('UserAccountServiceToken');

@Injectable({
  providedIn: 'root',
})
export class UserAccountService extends LookupDataServiceBase<UserAccount> {
  constructor(configService: ConfigService, http: HttpClient, private genderLookup: GenderLookupService) {
    super(configService, http);
  }

  override sortItems(items: UserAccount[]): UserAccount[] {
    return items.sort((a, b) => (a.id > b.id ? -1 : 1));
  }

  public override getDisplayName(data: UserAccount): string {
    return data.name;
  }
  protected override getServiceEndpoint(): string {
    return 'user_account';
  }
  public override getColumnDefs(): IColumnDef[] {
    return [
      {
        label: 'Name',
        dataKey: 'name',
        inGrid: true,
        editor: 'description',
      },
      {
        label: 'Name (Bangla)',
        dataKey: 'nameBangla',
        inGrid: false,
        editor: 'description',
      },
      {
        label: 'Email',
        dataKey: 'email',
        inGrid: true,
        editor: 'email',
      },
      {
        label: 'Gender',
        dataKey: 'gender',
        inGrid: false,
        editor: 'select',
        lookup: this.genderLookup,
      },
      {
        label: 'Address',
        dataKey: 'address',
        inGrid: false,
        editor: 'description',
      },
      {
        label: 'Zip',
        dataKey: 'zip',
        inGrid: false,
        editor: 'description',
        halfWidth: true
      },
      {
        label: 'City',
        dataKey: 'city',
        inGrid: true,
        editor: 'description',
        halfWidth: true
      },
      {
        label: 'Phone',
        dataKey: 'phone',
        inGrid: true,
        editor: 'description',
      },
      {
        label: 'Account Complete',
        dataKey: 'accountComplete',
        inGrid: true,
        hideInDetail:true,
        customComponent: 'checkbox',
        transform: (value: boolean) => {
          return value ? 'Yes' : 'No';
        },
      },
    ];
  }

  override postProcessGetAll(items: UserAccount[]): UserAccount[] {
    items.forEach((item) => {
      item.accountComplete =
        item.nameBangla !== undefined && !item['invitationCode'];
    });
    return items;
  }

  public getUserIdsHavingPermission(permission: PermissionType) {
    return this.http.get<number[]>(
      this.configService.getApiUrl() + 'users_with_permission/' + permission
    );
  }

  public sendInvitataionCode(userId: number) {
    const data = {
      userId: userId,
    };
    return this.postCustom<boolean>('send_invitation', data);
  }

  public requestPasswordReset(userId: number) {
    const data = {
      userId: userId,
    };
    return this.postCustom<boolean>('request_reset_password', data);
  }

  public requestEmailChange(email: string) {
    return this.getCustom('request_email_change/' + email);
  }

  public getEmailChangeInfo(userId: number): Observable<any> {
    return this.getCustomTyped<any>('email_change_info/' + userId);
  }
}
